import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';

let headers = {};

const BACKEND_URL = 'https://api.stikcon.com/api/'
// const BACKEND_URL = 'https://api.stikcon.com/api/'
// const BACKEND_URL = 'https://stikcon.aventusinformatics.com/api/'
// const BACKEND_URL = 'http://192.168.18.110:8001/api/'

const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers
});

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = reactLocalStorage.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    (response) =>
        new Promise((resolve, reject) => {
            resolve(response);
        }),
    (error) => {
        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        if (error.response.status === 403) {

        } else {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    },
);

export default axiosInstance;